<div class="btn-group">
    <button
        *ngIf="states.canDeleteMeasurements"
        type="button"
        class="btn-bx-secondary-stroked ml-1"
        tooltip="Delete"
        container="body"
        [disabled]="states.isEstimateReadonly"
        (click)="onDelete()">
        <i class="fa fa-trash"></i>
    </button>

    <button mat-icon-button class="btn-toggle" (click)="toggleCategory()" [disabled]="!measurementCategory.id">
        <i class="fa fa-chevron-up" [ngClass]="{ collaspe: !measurementCategory.isExpanded }" aria-hidden="true"></i>
    </button>
</div>
